import React, { useState, useEffect } from 'react';
import { Button } from "primereact/button";
import * as request from "../admin/lib/lib";
import { Dialog } from "primereact/dialog";

export function Grafik() {

    const [grafik, setGrafik] = useState(null);

    const [visible, setVisible] = useState(false);
    
    
    useEffect(() => {
        console.log('tesr');
        async function fetchGrafik() {
            try {
                const response = await request.get(`${process.env.REACT_APP_BACKEND_URL}GetInfo/Grafik`);
                setGrafik(response.grafik);
                setVisible(true);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }

        fetchGrafik();
    }, []); 

    return (
        <div className="pdf-container">
            <h2></h2>
            {grafik ? (
                <>
                    
                   
                    <object className="pdf-container"
                                data={`documents/schedule/${grafik}?v=${Date.now()}`}
                                type="application/pdf"
                                width="100%"
                                height="100vh"
                            >
                                <p>
                                    Вашият браузър не поддържа PDF визуализация.{" "}
                                    <a
                                        href={`documents/schedule/${grafik}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Изтегли PDF
                                    </a>
                                    .
                                </p>
                        </object>
                   
                       
                    
                </>
            ) : (
                <p>Зареждане на график...</p>
            )}
        </div>
    );
}

export default Grafik;